import { extend } from 'vee-validate';
import { required, email, confirmed } from 'vee-validate/dist/rules';

const moment = require('moment-timezone');

extend('required', {
  ...required,
  message: (name) => `${name} is required.`,
});

extend('email', {
  ...email,
});

extend('confirmed', {
  ...confirmed,
  message: (name, _) => 'Both fields must match.',
});

extend('date', {
  validate(value, args) {
    return moment(`${value.month}/${value.day}/${value.year}`, 'MM/DD/YYYY').isValid();
  },
  message: (name) => `${name} must be a valid date.`,
});

extend('past_date', {
  validate(value, args) {
    return moment(`${value.month}/${value.day}/${value.year}`, 'MM/DD/YYYY').isBefore(moment());
  },
  message: (name) => `${name} must be a past date.`,
});
